//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    name: "AQSearch",
    components: {
        AQInput
    },
    props: {
        value: { type: String, default: "" },
        resetSearchData: { type: Boolean, default: false },
        placeholder: { type: String, default() { return this.$t("generic.search"); } },
        openTrigger: { type: Boolean, default: false },
        debounce: { type: [String, Number] },
        closeSearchInput: { type: Boolean, default: false }
    },
    data() {
        return {
            searchModel: "",
            searchState: false
        };
    },
    watch: {
        value: {
            handler(value) {
                this.searchModel = value;
                if (this.closeSearchInput) {
                    this.searchState = false;
                }
            }
        },
        searchModel: {
            handler(value) {
                this.$emit("input", value);
            }
        },
        resetSearchData: {
            handler(value) {
                if (value) {
                    this.searchModel = "";
                    this.$emit("input", this.searchModel);
                    this.searchState = false;
                }
            }
        },
        openTrigger: {
            handler(value) {
                if (value) {
                    setTimeout(() => {
                        this.$refs.searchField.$refs.AQInput.focus();
                        this.searchState = true;
                    }, 0);
                }
            }
        }
    },
    deactivated() {
        this.searchModel = "";
        this.closeSearch();
        this.$refs.searchField.blur();
    },
    methods: {
        openSearch() {
            this.searchState = true;
            this.$refs.searchField.$refs.AQInput.focus();
        },
        closeSearch() {
            this.searchState = !!this.searchModel;
            this.$emit("blur");
        }
    }
};
